import { render, staticRenderFns } from "./CpButton.vue?vue&type=template&id=bed86eb2&"
import script from "./CpButton.vue?vue&type=script&lang=ts&"
export * from "./CpButton.vue?vue&type=script&lang=ts&"
import style0 from "./CpButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports